var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconawesomeFileExport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.784,
    height: 18.477,
    viewBox: "0 0 20.784 18.477",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-file-export",
    "data-name": "Icon awesome-file-export",
    d: "M6.927,4.4a.863.863,0,0,1,.253-.61L10.712.253A.865.865,0,0,1,11.326,0h.22V4.619H6.927ZM.179,11.115,3.632,7.636a.579.579,0,0,1,.989.408v2.349h2.31V12.7H4.621v2.353a.579.579,0,0,1-.989.408L.179,11.981A.614.614,0,0,1,.179,11.115Zm13.677,1.01V10.97a.579.579,0,0,0-.577-.577H6.927V5.774h4.908a.869.869,0,0,0,.866-.866V0h7.217a.864.864,0,0,1,.866.866V17.61a.864.864,0,0,1-.866.866H7.793a.864.864,0,0,1-.866-.866V12.7h6.351A.579.579,0,0,0,13.856,12.125Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomeFileExport);
export default __webpack_public_path__ + "static/media/Icon awesome-file-export.590994ef7bb8ff473026103e6875c0d8.svg";
export { ForwardRef as ReactComponent };